import {isRequired} from 'common/validators';

export const getRequiredValidator = ({required = false, requiredDisable = false}) => {
	return required && !requiredDisable ? [isRequired(required)] : [];
};



// WEBPACK FOOTER //
// ./src/common/fields/helpers/index.js